export default __webpack_public_path__ + "static/media/feature-icon-2.a2899b5c.svg";